/* Card — flat/padded surface container.
   Ported from lib/components.jsx (claude_design project 5c0836b6-facf-49dd-9c78-62afe3f7bc12). */

import React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  pad?: boolean;
  flat?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export function Card({
  pad,
  flat,
  className = '',
  children,
  ...rest
}: CardProps) {
  const cls = [
    'card',
    flat ? 'card-flat' : '',
    pad ? 'card-pad' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
}

export default Card;
